import { ImageGroup } from '../../types';
import { LABELS } from '../constants';

export const SECTION_KEYS = {
  CARRIER_IMAGES: 'carrier-images',
  PRO_IMAGES: 'pro-images',
} as const;

export type SectionKey = typeof SECTION_KEYS[keyof typeof SECTION_KEYS] | string;

export const getDefaultSelectionKey = (
  showCarrierImages: boolean,
): SectionKey => {
  if (showCarrierImages) {
    return SECTION_KEYS.CARRIER_IMAGES;
  }
  return SECTION_KEYS.PRO_IMAGES;
};

export const isValidSelection = (
  selectedKey: SectionKey,
  showCarrierImages: boolean,
  imageGroups: ImageGroup[]
): boolean => {
  if (selectedKey === SECTION_KEYS.CARRIER_IMAGES) {
    return showCarrierImages;
  }

  if (selectedKey === SECTION_KEYS.PRO_IMAGES) {
    return true;
  }

  return imageGroups.some(group => group.key === selectedKey);
};

export const getDisplayImages = (
  selectedKey: SectionKey,
  imageGroups: ImageGroup[]
): { images: any[]; label: string } => {
  if (selectedKey === SECTION_KEYS.PRO_IMAGES) {
    const allImages = imageGroups.flatMap(group => group.images);
    return {
      images: allImages,
      label: LABELS.PRO_IMAGES
    };
  }

  const selectedGroup = imageGroups.find(group => group.key === selectedKey);
  return {
    images: selectedGroup?.images || [],
    label: selectedGroup?.label || ''
  };
};
